import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchPaymentHistory = async (token) => {
  const res = await axios.get(`${baseUrl}/paymentHistotyApi/?portal=${portal}`, {
    headers: { Authorization: `Token ${token}` }
  });
  // Transform the response data to the required format without mapping serviceType
  res.data = Array.isArray(res.data)
    ? res.data.map(item => ({
        paymentDate: item.payment_date ? item.payment_date : "",
        nextPaymentDate: item.next_payment_date,
        serviceType: item.service_type,
        amount: item.amount,
        duration: String(item.duration)
      }))
    : [];
  return res.data;
}